import ChargeOperationStore, { ChargeOperationStoreTypes } from './chargeOperation';
import DeviceOperation, { DeviceOperationTypes } from './deviceOperation';
import DeviceBaseStore from './DeviceBase';
import DeviceSyncStore from './DeviceSync'; //云机同步数据
import DeviceModalStore from './DeviceModal';

export interface DeviceStoreTypes {
    ChargeOperationStore: ChargeOperationStoreTypes;
    DeviceOperation: DeviceOperationTypes;
    DeviceBaseStore: DeviceBaseStore;
    DeviceSyncStore: DeviceSyncStore;
    DeviceModalStore: DeviceModalStore;
}

const DeviceStore = {
    ChargeOperationStore,
    DeviceOperation,
    DeviceBaseStore: new DeviceBaseStore(),
    DeviceSyncStore: new DeviceSyncStore(),
    DeviceModalStore: new DeviceModalStore(),
}

export default DeviceStore;
